import { render, staticRenderFns } from "./actor-bio-form.vue?vue&type=template&id=11c185cb&scoped=true&"
import script from "./actor-bio-form.vue?vue&type=script&lang=ts&"
export * from "./actor-bio-form.vue?vue&type=script&lang=ts&"
import style0 from "./actor-bio-form.vue?vue&type=style&index=0&id=11c185cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c185cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VForm,VRow,VSelect,VTextField})
